/*
	OneSwatches 2.2.0 Usage (Webpack)
	Yang @onerockwell
	Adding option availablity check

	OneSwatches 2.1.0 Usage
	Yang @onerockwell
	Adding option availablity check
	
	OneSwatches 2.0.0 Usage
	Yang @onerockwell
	
	OneSwatches 1.0.0 Usage
	Yang & Patrick @onerockwell
*/

// Import all dependencies here
import _ from 'underscore';
import Backbone from 'backbone';
import { publish, PUB_SUB_EVENTS } from '@/lib/pubsub';

import '../../styles/modules/oneSwatch.scss';

// Define the Backbone View here (Optional)
let OneProductFormView = Backbone.View.extend({
	
    /**
     * @param {Boolean} settings.preSelect Pre-select the first variant
     * @param {Boolean} settings.updateURL Update the "variant" URL parameter on variant change
     */
	initialize: function(settings) {

        this.settings = settings || {};

        // Master ID input is disabled by default to give <noscript> form priority
        this.el.querySelector('[name="id"]').disabled = false;

        this.setVariant();
        this.onVariantChange();
        
        this.el.addEventListener('submit', e => this.onFormSubmit(e));
	},

	events: {
		'change': 'onVariantChange',
	},

	onFormSubmit: function(e) {
        e.preventDefault();

        this.handleErrorMessage();

        const formJson = {
            items: [
                {
                    id: Number(this.el.elements.id.value),
                    quantity: Number(this.el.elements.quantity.value)
                }
            ]
        };
        

        const formData = new FormData(this.el);
        const config = {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json'
            },
            body: JSON.stringify(formJson)
        };

        fetch('/cart/add.js', config)
            .then(response => response.json())
            .then(response => {
                if (response.status) {
                    publish(PUB_SUB_EVENTS.cartError, {
                        errors: response.errors || response.description,
                        message: response.message 
                    });
                    this.handleErrorMessage(response.description);
                } else {
                    publish(PUB_SUB_EVENTS.cartUpdate, response)
                }
            });
    },

    handleErrorMessage: function(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessage =
            this.errorMessage || this.el.querySelector('.form-errors');
        if (!this.errorMessage) return;

        this.errorMessage.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
        }
    },

    onVariantChange: function() {
        this.updateOptions();
        this.updateMasterId();
        this.updateVariantStatuses();
        this.updateAddButton();

        if (this.currentVariant) {
            this.updateVariantInput();
            this.settings.updateURL && this.updateURL();
            /* sets the afterpay installment amt if selected variant exist and afterpay message exist in PDP */
            this.updateAfterPayInstallmentAmt()
        }
    },

	/**
     *  Mark radios as checked if a variant is present in the URL params or if
     *  preSelect setting is true
     */
    setVariant: function() {
        const params = new URLSearchParams(window.location.search);
        const variantId = this.settings.preSelect ? 
            this.getVariantData()[0].id :
            params.get('variant');

        if (variantId) {
            this.currentVariant = this.getVariantData().find(variant => {
                return variant.id.toString() === variantId.toString();
            });
            if (this.currentVariant) {
                this.currentVariant.options.forEach(option => {
                    this.el.querySelector(`[value="${option}"]`).checked = true;
                });
            }
        }
    },

    updateAddButton: function() {
        this.numOptions = this.numOptions || this.el.querySelectorAll('fieldset').length;
        const addButton = this.el.querySelector('[name="add"]');
        const stickyAddButton = document.getElementById('sticky_atc');
        const addButtonText = this.el.querySelector('[name="add"] > .add-to-cart-text');
        const customSkuThresholds = {"143001":50,"143003":50,"709012":20,"709014":20,"709017":20,"709021":20,"709031":20,"709036":20,"709037":20,"709038":20,"709039":20,"709043":20,"709045":20,"709056":20,"709057":20,"709069":20,"709071":20,"710012":20,"710014":20,"710017":20,"710021":20,"710031":20,"710036":20,"710037":20,"710038":20,"710039":20,"710043":20,"710045":20,"710056":20,"710057":20,"710069":20,"710071":20,"711269":50,"711270":50,"717012":20,"717014":20,"717017":20,"717021":20,"717031":20,"717036":20,"717037":20,"717038":20,"717039":20,"717043":20,"717045":20,"717056":20,"717057":20,"717069":20,"717071":20,"759009":50,"775012":5,"775014":5,"775017":5,"775021":5,"775031":5,"775036":5,"775037":5,"775038":5,"775039":5,"775043":5,"775045":5,"775056":5,"775057":5,"775069":5,"775071":5,"776012":5,"776014":5,"776017":5,"776021":5,"776031":5,"776036":5,"776037":5,"776038":5,"776039":5,"776043":5,"776045":5,"776056":5,"776057":5,"776069":5,"776071":5,"777012":5,"777014":5,"777017":5,"777021":5,"777031":5,"777036":5,"777037":5,"777038":5,"777039":5,"777043":5,"777045":5,"777056":5,"777057":5,"777069":5,"777071":5,"785012":5,"785014":5,"785017":5,"785021":5,"785031":5,"785036":5,"785037":5,"785038":5,"785039":5,"785043":5,"785045":5,"785056":5,"785057":5,"785069":5,"785071":5,"786012":5,"786014":5,"786017":5,"786021":5,"786031":5,"786036":5,"786037":5,"786038":5,"786039":5,"786043":5,"786045":5,"786056":5,"786057":5,"786069":5,"786071":5,"787012":5,"787014":5,"787017":5,"787021":5,"787031":5,"787036":5,"787037":5,"787038":5,"787039":5,"787043":5,"787045":5,"787056":5,"787057":5,"787069":5,"787071":5};
        if (!addButton) return;
        const variantSKU = this.currentVariant.sku;
        let variantQty = this.currentVariant.inventory_quantity;
        let inventory_policy = this.currentVariant.inventory_policy;
        getAccurateInventory(this.currentVariant).then(qty => {
            if (qty !== null) {
                variantQty = qty;
                console.log("✅ Accurate qty:", variantQty);
            } else {
                console.log("⚠️ Falling back to legacy qty:", variantQty);
            }
            console.log(variantSKU + " variantQty: " + variantQty + " / oos_threshold: " + oos_threshold + " / " + inventory_policy);
            
            if (this.currentVariant && this.currentVariant.available && variantQty > oos_threshold || this.currentVariant.available && inventory_policy == 'continue') {
                addButton.removeAttribute('disabled');
                stickyAddButton.removeAttribute('disabled');
                // addButtonText.textContent = 'Add to Cart';
                if(addButton.classList.contains('pre-order')){
                    if(addButtonText && !addButtonText.textContent.toLowerCase().includes("pre order")){
                        addButtonText.textContent = 'Pre Order';
                    }
                } else {
                    if(addButtonText && !addButtonText.textContent.toLowerCase().includes("add to cart")){
                        addButtonText.textContent = 'Add to Cart';
                    }
                }
                // DD-3144 Changes for custom threshold
                if( Shopify.country == "US" && customSkuThresholds[variantSKU] && variantQty <= customSkuThresholds[variantSKU] ) {
                    addButton.setAttribute('disabled', 'disabled');
                    stickyAddButton.setAttribute('disabled', 'disabled');
                    if (addButtonText && !addButtonText.textContent.toLowerCase().includes("sold out")) {
                        addButtonText.textContent = 'Sold Out';
                    }
                }
            } else if (this.currentVariant && variantQty <= oos_threshold){
                addButton.setAttribute('disabled', 'disabled');
                stickyAddButton.setAttribute('disabled', 'disabled');
                if(addButtonText && !addButtonText.textContent.toLowerCase().includes("sold out")){
                    addButtonText.textContent = 'Sold Out';
                }
            } else if (this.currentVariant && !this.currentVariant.available){
                addButton.setAttribute('disabled', 'disabled');
                stickyAddButton.setAttribute('disabled', 'disabled');
                if(addButtonText && !addButtonText.textContent.toLowerCase().includes("sold out")){
                    addButtonText.textContent = 'Sold Out';
                }
            } else {
                addButton.setAttribute('disabled', 'disabled');
                stickyAddButton.setAttribute('disabled', 'disabled');
                if(this.options?.length < this.numOptions){
                    if(addButtonText && !addButtonText.textContent.toLowerCase().includes("sold out")){
                        addButtonText.textContent = 'Sold Out';
                    }
                } else{
                    if(addButtonText && !addButtonText.textContent.toLowerCase().includes("unavailable")){
                        addButtonText.textContent = 'Unavailable';
                    }
                }
            }

        });
    },

    updateOptions: function() {
        const fieldsets = Array.from(this.el.querySelectorAll('fieldset'));
        this.options = fieldsets.map(fieldset => {
            // Variables for variant specs
            let variant_specs_html = '';
            let variant_specs = document.getElementById('variant_specs');
            let variant = Array.from(fieldset.querySelectorAll('input')).find(input => input.checked);

            if(variant?.name == 'Length') {
              // Assigning the designated variant specs
              let specs_arr = [variant.dataset.length, variant.dataset.weight, variant.dataset.style, variant.dataset.pieces];
              // Removing empty strings from array
              specs_arr = specs_arr.filter(spec => spec !== '');
              // Constructing string with all available specs
              for(let i = 0; i < specs_arr.length; i++) {
                if(specs_arr[i] !== '') variant_specs_html += `${specs_arr[i]} ${[i] == specs_arr.length - 1 ? '' : '|' } `
              }
              // Setting variant specs element html
              variant_specs.innerHTML = variant_specs_html;
            }
            
            return Array.from(fieldset.querySelectorAll('input')).find(input => input.checked)?.value;
        }).filter(Boolean)
        publish(PUB_SUB_EVENTS.variantOptionsChange, this.options);
    },

    updateMasterId: function() {
        this.currentVariant = this.getVariantData().find(variant => {
            // Assumes that options appear in the same order as they do in the DOM
            return !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);
        });
        if (this.currentVariant) publish(PUB_SUB_EVENTS.variantChange, this.currentVariant);
    },

    // Mark radios as disabled depending on currently selected values
    updateVariantStatuses: function() {
        if (!this.el.querySelector(':checked')) return;
        const selectedOptionOneVariants = this.getVariantData().filter(
            (variant) => this.el.querySelector(':checked').value === variant.option1
        );
        const inputWrappers = [...this.el.querySelectorAll('fieldset')];
        inputWrappers.forEach((option, index) => {
            if (index === 0) return;
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
            const previousOptionSelected = inputWrappers[index - 1].querySelector('[checked],:checked');
            if (!previousOptionSelected) return;
            const availableOptionInputsValue = selectedOptionOneVariants
                .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected.value)
                .map((variantOption) => variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
    },

    setInputAvailability: function(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach((input) => {
            if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
                input.classList.remove('disabled');
            } else {
                input.classList.add('disabled');
            }
        });
    },

    getVariantData: function() {
        this.variantData = this.variantData || JSON.parse(this.el.querySelector('.variants-json').textContent);
        return this.variantData;
    },

    updateVariantInput: function() {
        const input = this.el.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
    },

    toggleAddButton: function(disable = true, text) {
        const productForm = this.el.querySelector('form.add-to-cart-form');
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > .add-to-cart-text');
        if (!addButton) return;
    
        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text && addButtonText) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            if(addButtonText && !addButtonText.textContent.toLowerCase().includes("add to cart")){
                addButtonText.textContent = 'Add to Cart';
            }
        }
    },

    updateURL: function() {
        if (this.currentVariant) {
            window.history.replaceState({}, '', `${window.location.pathname}?variant=${this.currentVariant.id}`);
        }
    },
    /**
     * DD-2804 Bellami Hair - Add AfterPay/ShopPay messaging to PDPs
     * NOTE: We onlh allow afterpay message for US customers
     * @returns void
     */
    updateAfterPayInstallmentAmt: function (){
        // update afterpay installment price if exist 
        const afterPayMsg = document.querySelector('[data-afterpay-msg]')
        if(!afterPayMsg){
            return 
        }
        const intallPrice = afterPayMsg.querySelector('.after-pay-installment')
        intallPrice.innerHTML = Shopify.formatMoney(this.currentVariant.price / 4 , window.theme.moneyFormat)
        
    },
	
	destroy: function() {
		var self = this;
		self.undelegateEvents();
	}

});

// Define the module here 
let OneProductForm = {
	init: function (settings) {
		return new OneProductFormView(settings);
	}
}

// Output the module
export default OneProductForm;

// more accurate way to get product inventory
async function getAccurateInventory(currentVariant) {
  const STOREFRONT_ACCESS_TOKEN = "4959b84ff65312d895f51bf57f38ada2"; 
  const SHOP_URL = "bellami-dev.myshopify.com";

  if (!currentVariant || !currentVariant.id) {
    console.warn("⚠️ No currentVariant provided.");
    return null;
  }

  const gid = `gid://shopify/ProductVariant/${currentVariant.id}`;

  const query = `
    query($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on ProductVariant {
          id
          availableForSale
          quantityAvailable
        }
      }
    }
  `;

  try {
    const response = await fetch(`https://${SHOP_URL}/api/2025-01/graphql.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN
      },
      body: JSON.stringify({ query, variables: { ids: [gid] } })
    });

    const json = await response.json();

    if (json.errors) {
      console.error("❌ GraphQL Errors:", json.errors);
      return null;
    }

    const node = json.data.nodes[0];
    if (!node) {
      console.error("❌ No ProductVariant found in response:", json);
      return null;
    }

    currentVariant.accurate_quantity = node.quantityAvailable;
    currentVariant.accurate_available = node.availableForSale;

    return node.quantityAvailable;
  } catch (err) {
    console.error("❌ Fetch failed:", err);
    return null;
  }
}
